<template>
  <v-container fluid class="px-0 py-0 question-container">
    <div class="question">
      <p v-for="qp in question.split('\n')" :key="qp" v-html="qp"></p>
    </div>
    <div class="attachs" v-if="attachs.length > 0">
      <p v-for="a in attachs" :key="a">
        <img style="max-width: 100%" :src="a" />
      </p>
    </div>
    <div class="sub-questions" v-if="type == 4">
      <div class="sub-questions" v-for="(sq, i) in subQues" :key="sq.id">
        <div class="question">
          <p v-for="(p, idx) in sq.title.split('\n')" :key="p">
            <span v-if="idx == 0">{{i+1}}.</span>
            <span v-html="p.trim()"></span>
          </p>
        </div>
        <div class="attachs" v-if="sq.rattachs.length > 0">
          <p v-for="a in sq.rattachs" :key="a">
            <img style="max-width: 100%" :src="a" />
          </p>
        </div>
        <div class="answer-list" v-else>
          <div class="list-item" v-for="ans in sq.ranswers" :key="ans">
            <v-icon class="icon">panorama_fish_eye</v-icon>
            <span v-html="ans"></span>
          </div>
        </div>
      </div>
    </div>
    <div class="answer-list" v-else>
      <div class="list-item" v-for="ans in answers" :key="ans">
        <v-icon class="icon">panorama_fish_eye</v-icon>
        <span v-html="ans"></span>
      </div>
    </div>
  </v-container>
</template>

<script>
export default {
  name: "question-view",
  data() {
    return {
      question: "",
      answers: [],
      attachs: [],
      subQuests: [],
      type: 1
    };
  },
  props: {
    cfg: Object
  },
  beforeMount() {
    this.init(this.cfg);
  },
  watch: {
    cfg(val) {
      this.init(val);
    }
  },
  methods: {
    parseQuestion(q, subQues) {
      let self = this,
        attachs = q.attachs ? q.attachs.split(",") : [],
        rattachs = [];
      for (let a of attachs) {
        rattachs.push(
          `${self.$const.baseUrl}/home/my/question/img/${q.id}/${a.split("/")[0]
          }`
        );
      }
      q.rattachs = rattachs;
      q.type = self.$dictVal(q.type);

      if (q.type == 2) {
        q.ranswers = ["正确", "错误"];
      } else if (q.type == 4) {
        if (subQues) {
          subQues.forEach(e => {
            self.parseQuestion(e);
          });
        }
        self.subQues = subQues;
      } else {
        q.ranswers = [
          q.opt1 || "",
          q.opt2 || "",
          q.opt3 || "",
          q.opt4 || "",
          q.opt5 || "",
          q.opt6 || ""
        ].filter(ans => ans != "");
      }
      return q;
    },
    init(cfg) {
      let self = this;
      self.$axios.get(`/home/my/question/get/${cfg.targetId}`).then(r => {
        if (r && r.data && r.data.status === "ok") {
          let q = self.parseQuestion(r.data.message, r.data.subQues);
          self.type = q.type;
          self.question = q.title;
          self.attachs = q.rattachs;
          self.answers = q.ranswers;
        }
      });
    }
  }
};
</script>

<style scoped>
/* .question-container .question {
  font-size: 18px;
} */
.question-container .answer-list {
  /* margin-top: 15px; */
  margin-left: 15px;
}

.question-container .answer-list .list-item {
  /* font-size: 16px; */
  /* margin-bottom: 10px; */
  display: flex;
  align-items: center;
}

.question-container .answer-list .list-item .icon {
  font-size: 16px;
}

.question-container .answer-list .list-item span {
  margin-left: 5px;
}
</style>